module.exports = __webpack_public_path__ + "img/coche.aa253656.webp";